import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import * as moment from 'moment';
import { SelectItem } from 'primeng/api';
import {
  ServicioOrdenamientosService,
  ParametrosOrdenamientosEntity,
  FiltrosOrdenMedicamentosEntity
} from 'src/app/services/servicio-ordenamientos.service';

@Component({
  selector: 'app-header-orden-medicamentos',
  templateUrl: './header-orden-medicamentos.component.html',
  styleUrls: ['./header-orden-medicamentos.component.css']
})
export class HeaderOrdenMedicamentosComponent implements OnInit {

  @Input() parametros: ParametrosOrdenamientosEntity;
  @Output() filtrosSeleccionados: EventEmitter<any>;
  @Output() errorGenerado: EventEmitter<any>;
  @Output() mensajeCarga: EventEmitter<any>;

  filtros: FiltrosOrdenMedicamentosEntity = {} as FiltrosOrdenMedicamentosEntity;
  dxAdicionales: SelectItem[] = [];
  profesionales: SelectItem[] = [];
  suministros: SelectItem[] = [];

  constructor(private ordenamientosService: ServicioOrdenamientosService) {
    this.filtrosSeleccionados = new EventEmitter();
    this.errorGenerado = new EventEmitter();
    this.mensajeCarga = new EventEmitter();

    this.filtros = {
      fechaInicio: moment().format('YYYY-MM-DD'),
      fechaFin: moment().format('YYYY-MM-DD'),
      dxAdicionales: [],
      profesionales: [],
      suministros: [],
      discriminarTipo: false,
      impresionMedicamentos: false
    }
  }

  ngOnInit() {
    this.getProfesionales();
    this.getDiagnosticosAdicionales();
  }

  async getProfesionales() {
    this.mensajeCarga.emit('Cargando lista de profesionales');
    const { fechaInicio, fechaFin } = this.filtros
    let response = await this.ordenamientosService
      .getProfesionalesSolicitud(this.parametros, fechaInicio, fechaFin, 2);

    this.profesionales = [];
    this.filtros.profesionales = [];
    response.subscribe((data: any) => {
      if (data && data['#result-set-1'].length > 0) {
        data['#result-set-1'].forEach(profesional => {
          this.profesionales.push({
            label: profesional['prfsnl'],
            value: profesional['unco']
          });
          this.filtros.profesionales.push(profesional['unco']);
        });
      }
      this.getProcedimientos();
    }, (error) => {
      console.log('Error HeaderOrdenMedicamentosComponent.getProfesionales()', error);
      this.errorGenerado.emit('Ocurrió un error al cargar la lista de profesionales, verifique conexión a internet e intente de nuevo. De lo contrario reporte caso al administrador.');
    });
  }

  async getProcedimientos() {
    this.mensajeCarga.emit('Cargando lista de suministros');
    const { fechaInicio, fechaFin } = this.filtros
    const profesionales = this.profesionales.map(prof => prof.value).toString();
    let response = await this.ordenamientosService
      .getServiciosDisponibles(this.parametros, fechaInicio, fechaFin, profesionales, 2);

    this.suministros = [];
    this.filtros.suministros = [];
    response.subscribe((data: any) => {
      if (data && data['#result-set-1'].length > 0) {
        data['#result-set-1'].forEach(procedimiento => {
          this.suministros.push({
            label: procedimiento['itm'],
            value: procedimiento['unco']
          });
          this.filtros.suministros.push(procedimiento['unco']);
        });
      }
      this.mensajeCarga.emit(null);
    }, (error) => {
      console.log('Error HeaderOrdenMedicamentosComponent.getProcedimientos()', error);
      this.errorGenerado.emit('Ocurrió un error al cargar la lista de procedmientos, verifique conexión a internet e intente de nuevo. De lo contrario reporte caso al administrador.');
    });
  }

  async getDiagnosticosAdicionales() {
    try {
      const response = await this.ordenamientosService.getDiagnosticosAdicionales(this.parametros);
      response.subscribe((data: any) => {
        if (data) {
          data['dxAdicionales'].forEach(dx => {
            this.dxAdicionales.push({
              label: dx['descripcion'],
              value: dx['codigo']
            });
            this.filtros.dxAdicionales.push(dx['codigo']);
          })
        }
      }, (err) => {
        console.error('Error HeaderOrdenMedicamentosComponent.getDiagnosticosAdicionales()', err);
        this.errorGenerado.emit('Error al obtener los diagnosticos adicionales, verifique conexión a internet e intente de nuevo. De lo contrario reporte caso al administrador.');
      });
    } catch (e) {
      console.error('Catch HeaderOrdenMedicamentosComponent.getDiagnosticosAdicionales()', e);
      this.errorGenerado.emit('Error grave al obtener los diagnosticos adicionales, verifique conexión a internet e intente de nuevo. De lo contrario reporte caso al administrador.');
    }
  }

  onCambioFecha() {
    this.getProfesionales();
  }

  onGenerar() {
    const { fechaInicio, fechaFin, profesionales, suministros } = this.filtros;
    if (fechaInicio.length === 0) {
      this.errorGenerado.emit('<strong>Fecha Inicial</strong> debe ser una fecha válida.');
    } else if (fechaFin.length === 0) {
      this.errorGenerado.emit('<strong>Fecha Final</strong> debe ser una fecha válida.');
    } else if (profesionales.length === 0) {
      this.errorGenerado.emit('Debe seleccionar al menos un <strong>Profesional</strong>.');
    } else if (suministros.length === 0) {
      this.errorGenerado.emit('Debe seleccionar al menos un <strong>Suministro</strong>.');
    } else {
      this.filtrosSeleccionados.emit(this.filtros);
    }
  }

  onImprimir() {
    let printContents: any, popupWin: any;
    printContents = document.getElementById('reporte-ordenes-servicios').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();

    popupWin.document.write(`
      <html>
        <head>
          <title> Standard Health | Reportes </title>
          <link rel="stylesheet"
          href="https://stackpath.bootstrapcdn.com/bootstrap/4.1.3/css/bootstrap.min.css" integrity="sha384-MCw98/SFnGE8fJT3GXwEOngsV7Zt27NXFoaoApmYm81iuXoPkFOJwJ8ERdknLPMO"
          crossorigin="anonymous">
          <style>
            /* Tamaños fuentes */

            .font-title {
                font-size: 150px;
            }

            .font-subtitle {
                font-size: 30px;
            }

            .font-normal {
                font-size: 16px;
            }
          </style>
        </head>
        <body onload="window.print();window.close()">${ printContents}</body>
      </html>`
    );
    popupWin.document.close();
  }
}
